module.exports = __webpack_public_path__ + "static/media/hotelGoiania01.0fd76f0b.jpg";